require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./study-security-watchdog-d-365.json") })
        }
      }, "path---study-security-watchdog-d-365");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---study-security-watchdog-d-365!./.cache/json/study-security-watchdog-d-365.json
// module id = 931
// module chunks = 231608221292675